/* eslint-disable @typescript-eslint/no-namespace, @typescript-eslint/array-type, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types, @typescript-eslint/consistent-indexed-object-style, @typescript-eslint/no-redundant-type-constituents */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import type * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ListAuditLogsQueryVariables = Types.Exact<{
  input: Types.AuditLogInput;
}>;


export type ListAuditLogsQuery = { __typename?: 'Query', listAuditLogs: { __typename?: 'AuditLogsResponse', total: number, data: Array<{ __typename?: 'AuditLogModel', event_id: string, vitall_patient_id?: string | null, event_type: string, event_resource?: string | null, event_details?: string | null, created_at: string, user?: { __typename?: 'AuditLogUserModel', user_id: string, first_name: string, last_name: string } | null }> } };

export type ListAuditLogUsersQueryVariables = Types.Exact<{
  input: Types.AuditLogInput;
}>;


export type ListAuditLogUsersQuery = { __typename?: 'Query', listAuditLogs: { __typename?: 'AuditLogsResponse', data: Array<{ __typename?: 'AuditLogModel', user?: { __typename?: 'AuditLogUserModel', user_id: string, first_name: string, last_name: string } | null }> } };


export const ListAuditLogsDocument = gql`
    query listAuditLogs($input: AuditLogInput!) {
  listAuditLogs(input: $input) {
    total
    data {
      event_id
      vitall_patient_id
      event_type
      event_resource
      event_details
      created_at
      user {
        user_id
        first_name
        last_name
      }
    }
  }
}
    `;
export function useListAuditLogsQuery(baseOptions: Apollo.QueryHookOptions<ListAuditLogsQuery, ListAuditLogsQueryVariables> & ({ variables: ListAuditLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAuditLogsQuery, ListAuditLogsQueryVariables>(ListAuditLogsDocument, options);
      }
export function useListAuditLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAuditLogsQuery, ListAuditLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAuditLogsQuery, ListAuditLogsQueryVariables>(ListAuditLogsDocument, options);
        }
// @ts-ignore
export function useListAuditLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListAuditLogsQuery, ListAuditLogsQueryVariables>): Apollo.UseSuspenseQueryResult<ListAuditLogsQuery, ListAuditLogsQueryVariables>;
export function useListAuditLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAuditLogsQuery, ListAuditLogsQueryVariables>): Apollo.UseSuspenseQueryResult<ListAuditLogsQuery | undefined, ListAuditLogsQueryVariables>;
export function useListAuditLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAuditLogsQuery, ListAuditLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAuditLogsQuery, ListAuditLogsQueryVariables>(ListAuditLogsDocument, options);
        }
export type ListAuditLogsQueryHookResult = ReturnType<typeof useListAuditLogsQuery>;
export type ListAuditLogsLazyQueryHookResult = ReturnType<typeof useListAuditLogsLazyQuery>;
export type ListAuditLogsSuspenseQueryHookResult = ReturnType<typeof useListAuditLogsSuspenseQuery>;
export type ListAuditLogsQueryResult = Apollo.QueryResult<ListAuditLogsQuery, ListAuditLogsQueryVariables>;
export const ListAuditLogUsersDocument = gql`
    query listAuditLogUsers($input: AuditLogInput!) {
  listAuditLogs(input: $input) {
    data {
      user {
        user_id
        first_name
        last_name
      }
    }
  }
}
    `;
export function useListAuditLogUsersQuery(baseOptions: Apollo.QueryHookOptions<ListAuditLogUsersQuery, ListAuditLogUsersQueryVariables> & ({ variables: ListAuditLogUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAuditLogUsersQuery, ListAuditLogUsersQueryVariables>(ListAuditLogUsersDocument, options);
      }
export function useListAuditLogUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAuditLogUsersQuery, ListAuditLogUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAuditLogUsersQuery, ListAuditLogUsersQueryVariables>(ListAuditLogUsersDocument, options);
        }
// @ts-ignore
export function useListAuditLogUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListAuditLogUsersQuery, ListAuditLogUsersQueryVariables>): Apollo.UseSuspenseQueryResult<ListAuditLogUsersQuery, ListAuditLogUsersQueryVariables>;
export function useListAuditLogUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAuditLogUsersQuery, ListAuditLogUsersQueryVariables>): Apollo.UseSuspenseQueryResult<ListAuditLogUsersQuery | undefined, ListAuditLogUsersQueryVariables>;
export function useListAuditLogUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAuditLogUsersQuery, ListAuditLogUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAuditLogUsersQuery, ListAuditLogUsersQueryVariables>(ListAuditLogUsersDocument, options);
        }
export type ListAuditLogUsersQueryHookResult = ReturnType<typeof useListAuditLogUsersQuery>;
export type ListAuditLogUsersLazyQueryHookResult = ReturnType<typeof useListAuditLogUsersLazyQuery>;
export type ListAuditLogUsersSuspenseQueryHookResult = ReturnType<typeof useListAuditLogUsersSuspenseQuery>;
export type ListAuditLogUsersQueryResult = Apollo.QueryResult<ListAuditLogUsersQuery, ListAuditLogUsersQueryVariables>;
import { withMutationResponseHandler, withQueryResponseHandler } from '../hooks/useResponseHandler';
export const useListAuditLogs = withQueryResponseHandler(useListAuditLogsQuery);
export const useListAuditLogUsers = withQueryResponseHandler(useListAuditLogUsersQuery);
